type PrepareConditionalSwrArgs<T> = {
    key: string;
    fetcher: T;
    condition: boolean;
};

const prepareConditionalSwrArgs = <T>({
    key,
    fetcher,
    condition,
}: PrepareConditionalSwrArgs<T>): [string | null, T | null] => {
    if (!condition) {
        return [null, null];
    }

    return [key, fetcher];
};

export { prepareConditionalSwrArgs };
